export default __webpack_public_path__ + "media/empty/empty-transfers-a83c7b26.jpg";